import React from "react";

/**
 * Dark "Command Center" browser frame used to wrap feature UI mockups.
 * Renders 3 window dots, a mono URL bar, and a dark-themed content slot.
 *
 * Props:
 *  url       — fake URL shown in the URL bar (default app.fixlr.app)
 *  imageSrc  — OPTIONAL. Relative URL under /marketing-shots/. If provided AND
 *              the file loads successfully, it replaces the `children` mock.
 *              If the image 404s (or the capture script hasn't run), we
 *              gracefully fall back to the children-driven CSS mock.
 *  children  — CSS/Tailwind-composited mock (always a safe fallback).
 */
export default function BrowserFrame({ url = "app.fixlr.app", imageSrc, children, className = "" }) {
  const [imgOk, setImgOk] = React.useState(Boolean(imageSrc));
  const hasImage = Boolean(imageSrc) && imgOk;
  return (
    <div className={`mk-browser-frame ${className}`} data-testid="mk-browser-frame">
      <div className="mk-browser-chrome">
        <span className="mk-browser-dot" style={{ background: "#ef4444" }} />
        <span className="mk-browser-dot" style={{ background: "#f59e0b" }} />
        <span className="mk-browser-dot" style={{ background: "#10b981" }} />
        <span className="mk-browser-url">https://{url}</span>
        <span className="mk-mono text-[9px] text-[var(--mk-text-muted)]">LIVE</span>
      </div>
      <div className="relative">
        {hasImage ? (
          <img
            src={imageSrc}
            alt=""
            loading="lazy"
            onError={() => setImgOk(false)}
            className="block w-full h-auto"
            style={{ display: "block", maxHeight: 520, objectFit: "cover", objectPosition: "top" }}
          />
        ) : (
          children
        )}
      </div>
    </div>
  );
}
